import React, { useState, useRef, useEffect } from "react";
import Modal from "./Modal";
import { MODAL_CLOSE } from "src/constants/images";
// import {
//   CROWN_REDEMPTION
// } from "src/constants/routes";
import { useNavigate } from "react-router-dom";


const GGRewardDisplayModal = ({ onClose, isVisible, userGGReward, bOMMreward500kPool }) => {
  const month_names_short = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const dateFormatter = (date) => {
    // console.log(date);
    let year = date.split("-")[0];
    let month = date.split("-")[1];
    if (month.length == 1) {
      month = "0" + month;
    }
    // console.log(`${year}-${month}`);
    return `${year}-${month}`;
  };

  const navigate = useNavigate();

  return (
    <Modal
      isVisible={isVisible}
      overlayClass="overlay"
      className="ggRewardDisplay card "
    >
      <div className="header px-4 py-3">
        <div>
          <h4>$CROWN Reward Distribution</h4>
          <p className="subTitle">
            GangstaBet Governance Token distribution details.
          </p>
        </div>
        <div
          onClick={() => onClose()}
          onKeyPress={(e) => e.code == "Enter" && onClose()}
          className="close-modal"
        >
          <img src={MODAL_CLOSE.SOURCE} alt="close" />
        </div>
      </div>
      <div className="mcg-body py-2">
        <div className="block px-4 py-2">
          <div className="d-flex">
            <h5>
              $CROWN earned by staking{" "}
              <span className="omm-icon">
                (ICON &{" "}
                <span className="omm">
                  <span className="gg-tt">
                    If you have voted through bOMM, please stake at least 1 ICX
                    to GangstaBet P-Rep via ICONex or MIW.
                  </span>
                  bOMM
                </span>
                )
              </span>{" "}
            </h5>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="18px"
              viewBox="0 0 24 24"
              onClick={() => {
                window.open(
                  "https://gangstabet.medium.com/1-000-000-gangstabet-governance-token-gg-november-2021-reward-pool-4cc3ee8bcea",
                  "_blank"
                );
              }}
              width="18px"
              className="mx-1"
              fill="#0d6efd"
            >
              <path d="M0 0h24v24H0z" fill="none" />
              <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z" />
            </svg>
          </div>
          <div className="staking">
            {userGGReward?.reward_logs?.map(({ date_stamp, gg_reward }) => {
              return (
                <div className="months d-flex">
                  <div>{`${month_names_short[
                    new Date(dateFormatter(date_stamp)).getUTCMonth()
                  ]
                    }, ${new Date(
                      dateFormatter(date_stamp)
                    ).getUTCFullYear()}`}</div>
                  <div>
                    {gg_reward} <span className="gg_token_unit">$CROWN</span>
                  </div>
                </div>
              );
            })}
            <div className="months total d-flex">
              <div>Total</div>
              <div>
                {userGGReward?.rewards?.staking_gg_reward
                  ? userGGReward?.rewards?.staking_gg_reward
                  : 0}{" "}
                <span className="gg_token_unit">$CROWN</span>
              </div>
            </div>
          </div>
        </div>
        <div className="block px-4 py-2">
          <div className="d-flex">
            <h5>$CROWN earned by adding liquidity</h5>
            <svg
              href=""
              xmlns="http://www.w3.org/2000/svg"
              height="18px"
              viewBox="0 0 24 24"
              width="18px"
              className="mx-1"
              fill="#0d6efd"
              onClick={() => {
                window.open(
                  "https://gangstabet.medium.com/gbet-bnusd-listed-in-balanced-dex-with-300-000-gg-monthly-reward-85a3722714c7",
                  "_blank"
                );
              }}
            >
              <path d="M0 0h24v24H0z" fill="none" />
              <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z" />
            </svg>
          </div>
          <div className="staking">
            <div className="months total d-flex">
              <div>Total</div>
              <div>
                {" "}
                {userGGReward?.rewards?.lp_gg_reward
                  ? userGGReward?.rewards?.lp_gg_reward
                  : 0}{" "}
                <span className="gg_token_unit">$CROWN</span>
              </div>
            </div>
          </div>
        </div>
        {bOMMreward500kPool > 0 && (<div className="block px-4 py-2">
          <div className="d-flex">
            <h5>$CROWN earned from 500K July pool</h5>
            <svg
              href=""
              xmlns="http://www.w3.org/2000/svg"
              height="18px"
              viewBox="0 0 24 24"
              width="18px"
              className="mx-1"
              fill="#0d6efd"
              onClick={() => {
                window.open(
                  "https://link.medium.com/MjEudSMxMrb"
                );
              }}
            >
              <path d="M0 0h24v24H0z" fill="none" />
              <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z" />
            </svg>
          </div>
          <div className="staking">
            <div className="months total d-flex">
              <div>Total</div>
              <div>
                {" "}
                {bOMMreward500kPool}
                <span className="gg_token_unit">{" "}$CROWN</span>
              </div>
            </div>
          </div>
        </div>)}

      </div>
      <div className="mcg-info px-1 py-1">
        <div className="d-flex">
          <div>Total: </div>
          <div className="gbet-value">
            {userGGReward?.rewards?.total_gg_reward
              ? userGGReward?.rewards?.total_gg_reward + bOMMreward500kPool
              : 0}{" "}
            <span className="gg_token_unit">$CROWN</span>
          </div>
        </div>
        {/* <div>
          <button
            className="blue"
            onClick={() => {
              navigate(CROWN_REDEMPTION.INDEX);
            }}
          >
            Claim
          </button>
        </div> */}
      </div>
      <div className="mcg-footer px-4 py-3"></div>
    </Modal>
  );
};

export default GGRewardDisplayModal;
